import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { FilterTable } from 'gnos-tables'
import cx from 'classnames'
import _ from 'lodash'

import InactivityIndicatorHeader from '../../../../../../../../../../../components/TableCell/components/InactiveIndicator/Header'
import InactiveIndicatorCell from '../../../../../../../../../../../components/TableCell/components/InactiveIndicator/Cell'
import NoData from '../../../../../../../../../components/Workspace/components/NoData'
import CustomDate from '../../../../../../../../../../../components/CustomDate'
import Currency from '../../../../../../../../../../../components/Currency'
import FormattedNumber from '../../../../../../../../../../../components/FormattedNumber'
import CellStyleWrapper from '../../../../../../../../../../../components/TableCell/components/CellStyleWrapper'
import Link from '../../../../../../../../../../../components/TableCell/components/Link'
import FailedLoad from '../../../../../../../../../components/Workspace/components/FailedLoad'
import Counter from '../../../../../../../../../../../components/Counter'

import { LOCALE_PREFIX } from '../../constants'

import SubTable from './components/SubTable'

import hocConnect from './hocConnect'
import './style.scss'

@injectIntl
@hocConnect
export default class Liens extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        companyAsCreditorLoadTableData: PropTypes.func.isRequired,
        companyAsCreditorTableChange: PropTypes.func.isRequired,
        customData: PropTypes.object,
        data: PropTypes.array,
        dataLocale: PropTypes.string,
        failed: PropTypes.bool,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        isLoading: PropTypes.bool,
        level: PropTypes.string.isRequired,
        loaded: PropTypes.bool,
        locale: PropTypes.string.isRequired,
        locked: PropTypes.bool,
        module: PropTypes.string.isRequired,
        pagination: PropTypes.object,
        filter: PropTypes.object,
        sorted: PropTypes.array,
        tableId: PropTypes.string.isRequired,
        tableSelector: PropTypes.string.isRequired,
    }

    componentDidMount() {
        const { loaded, dataLocale, locale } = this.props

        if (!loaded || dataLocale !== locale) this.loadData()
    }

    shouldComponentUpdate(nextProps) {
        const {
            customData,
            data,
            isLoading,
            level,
            locale,
            pagination,
            sorted,
            tableId,
            failed,
            loaded,
            tableSelector,
            filter,
        } = this.props

        if (!_.isEqual(customData, nextProps.customData)) return true
        if (!_.isEqual(data, nextProps.data)) return true
        if (!_.isEqual(isLoading, nextProps.isLoading)) return true
        if (!_.isEqual(level, nextProps.level)) return true
        if (!_.isEqual(locale, nextProps.locale)) return true
        if (!_.isEqual(pagination, nextProps.pagination)) return true
        if (!_.isEqual(sorted, nextProps.sorted)) return true
        if (!_.isEqual(failed, nextProps.failed)) return true
        if (!_.isEqual(loaded, nextProps.loaded)) return true
        if (!_.isEqual(tableId, nextProps.tableId)) return true
        if (!_.isEqual(tableSelector, nextProps.tableSelector)) return true
        if (!_.isEqual(filter, nextProps.filter)) return true

        return false
    }

    componentDidUpdate(prevProps) {
        const { level, locale, dataLocale } = this.props

        if (prevProps.level !== level) this.loadData()
        if (locale !== dataLocale && dataLocale) this.loadData()
    }

    loadData = () => {
        const { tableId, tableSelector, id, module, block, level, customData, companyAsCreditorLoadTableData } =
            this.props

        companyAsCreditorLoadTableData(tableId, tableSelector, id, module, block, level, customData)
    }

    handleTableChange = (changeData) => {
        const { tableId, tableSelector, id, module, block, level, customData, companyAsCreditorTableChange } =
            this.props

        companyAsCreditorTableChange(tableId, tableSelector, id, module, block, level, customData, changeData)
    }

    renderSubComponent = (rowData) => {
        const { id, intl } = this.props
        const rowIndex = _.get(rowData, 'row.index', null)
        const creditors = _.get(rowData, 'row.original.participants.creditor', [])
        const debtors = _.get(rowData, 'row.original.participants.debtor', [])

        return <SubTable id={id} intl={intl} rowIndex={rowIndex} creditors={creditors} debtors={debtors} />
    }

    render() {
        const { tableId, intl, data, isLoading, pagination, sorted, failed, maxGuarantee, locked, filter } = this.props

        if (locked && !isLoading && !failed) {
            return (
                <div className={'cac-liens'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.lockedTab` })} />
                </div>
            )
        }

        if (failed && !isLoading) {
            return (
                <div className={'cac-liens'}>
                    <FailedLoad
                        customCallback={this.loadData}
                        customText={intl.formatMessage({ id: 'global.failedToLoadTabContent' })}
                        show
                    />
                </div>
            )
        }

        if (_.isEmpty(data) && !isLoading && _.isEmpty(filter?.activeFilters)) {
            return (
                <div className={'cac-liens'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.noLiensData` })} />
                </div>
            )
        }

        return (
            <div className={'cac-liens'}>
                <div className={'guarantee-counter-wrapper'}>
                    <Counter
                        leftValue={{
                            value: (
                                <FormattedNumber
                                    value={maxGuarantee?.amount}
                                    decimalPlaces={0}
                                    currency={maxGuarantee?.currency}
                                    currencyStyle={{
                                        fontSize: '28px',
                                        fontFamily: 'Trivia Sans Light, sans-serif',
                                    }}
                                    displayUnits
                                    displayCurrency
                                />
                            ),
                        }}
                        description={
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.guaranteeDesc`}
                                values={{
                                    br: <br />,
                                    currency: maxGuarantee?.currency,
                                }}
                            />
                        }
                    />
                </div>
                <FilterTable
                    id={tableId}
                    data={data ?? []}
                    loading={isLoading}
                    itemIdentifier={'listId'}
                    columnsDefinition={[
                        {
                            accessor: 'inactive',
                            id: 'activity',
                            Header: ({ Controls }) => (
                                <>
                                    {Controls}
                                    <InactivityIndicatorHeader />
                                </>
                            ),
                            filterable: true,
                            filter: {
                                type: 'VALUE',
                                value: _.map(
                                    _.get(filter, 'availableParameters.activity.availableValues', []),
                                    (x) => ({
                                        value: _.get(x, 'value', null),
                                        item: _.get(x, 'title', null),
                                    })
                                ),
                            },
                            Cell: (value) => <InactiveIndicatorCell inactive={_.get(value, 'value', false)} />,
                            width: 35,
                        },
                        {
                            accessor: 'fileNumber',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.fileNumber` }),
                            Cell: (value) =>
                                !_.isNil(_.get(value, 'value')) && (
                                    <div
                                        className={cx(
                                            'centered-cell',
                                            _.get(value, 'original.inactive', false) && 'inactive'
                                        )}
                                    >
                                        <Link
                                            label={_.get(value, 'value', '')}
                                            url={`https://www.notar.sk/zalozne-prava/?actNumber1=${
                                                value?.value.split('/')[0]
                                            }&actNumber2=${value?.value.split('/')[1]}&lien-search=H%C4%BEada%C5%A5`}
                                            showIcon
                                            openOnNewTab
                                            iconType={'external'}
                                        />
                                    </div>
                                ),
                            width: 140,
                        },
                        {
                            accessor: 'maxGuaranteeAmount',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.maxPrincipal` }),
                            sortable: true,
                            Cell: (value) => (
                                <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                    <span style={{ textAlign: 'right' }}>
                                        <FormattedNumber value={_.get(value, 'value.amount', '-')} customBase={1} />
                                    </span>
                                </CellStyleWrapper>
                            ),
                        },
                        {
                            id: 'currency',
                            accessor: 'maxGuaranteeAmount',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.currency` }),
                            width: 60,
                            Cell: (value) => (
                                <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                    <Currency currency={value?.value?.currency} />
                                </CellStyleWrapper>
                            ),
                            filterable: true,
                            filter: {
                                type: 'VALUE',
                                value: _.map(
                                    _.get(filter, 'availableParameters.currency.availableValues', []),
                                    (x) => ({
                                        value: _.get(x, 'value', null),
                                        item: _.get(x, 'title', null),
                                    })
                                ),
                            },
                        },
                        {
                            accessor: 'startDate',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.dateFrom` }),
                            width: 120,
                            sortable: true,
                            Cell: (value) =>
                                !_.isNil(_.get(value, 'value.value')) && (
                                    <CellStyleWrapper isNotActive={value?.original?.inactive}>
                                        <CustomDate date={_.get(value, 'value.value', null)} precision={'days'} />
                                    </CellStyleWrapper>
                                ),
                        },
                    ]}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    settings={{
                        pagination,
                        sorted,
                        filtered: (filter?.activeFilters ?? []).map((actFilter) => ({
                            id: actFilter?.id,
                            value: actFilter?.value || [],
                        })),
                    }}
                    onTableChange={this.handleTableChange}
                    texts={{
                        pagination: {
                            page: intl.formatMessage({ id: 'global.page' }),
                            from: intl.formatMessage({ id: 'global.of' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                        filter: {
                            valueTitle: intl.formatMessage({ id: 'global.valueTitle' }),
                            fulltextTitle: intl.formatMessage({ id: 'global.fulltextTitle' }),
                        },
                    }}
                    SubComponent={(rowData) => this.renderSubComponent(rowData)}
                    expandOnRowClick
                />
            </div>
        )
    }
}
